var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Page',{attrs:{"head":"Minerva Archer is a front-end web developer in New York."}},_vm._l((_vm.items),function(item){return _c('ProjectPreview',_vm._b({key:item.id},'ProjectPreview',item,false))}))}
var staticRenderFns = []

export { render, staticRenderFns }